import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BasemodelService } from './basemodel.service';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataServiceService {
    private userFormsCache: any = null;
  constructor(public http: HttpClient, private base: BasemodelService) { }
  private token = " "
  baseUrl = environment.masterDomain + "/anonymouseUser/login/schoolSearch?searchCriteria=";


  //========counselling form ======//

  // refferded(searchreffered: any) {
  //   const headers = new HttpHeaders({
  //     'Authorization': ` ${this.token}`
  //   });
  //   return this.http.get(environment.counsellingUrl +"/ses/student/refferdEmpDetails?payrollId=" + searchreffered, { headers })
  // }

  //====== Academic counselling form ===========//

  Academicsearch(academicTerm: string) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    const requestBody = {
      "businessType": "COLLEGE",
      "searchKey": academicTerm,
    };
    return this.http.post(this.base.getcounsellingURL() + "/auth/jwt/student/counsel/studentSearch", requestBody, { headers });
  }

  AcademicsearchData(academicTerm: string) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getcounsellingURL() + "/auth/jwt/student/academicCounsel/testDetails?admNo=" + academicTerm, { headers });
  }

  Academicsubjectselected(subjectId: number, admNo: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getcounsellingURL() + "/auth/jwt/student/academicCounsel/facultyDetails?subjectId=" + subjectId + '&' + 'admNo=' + admNo, { headers });
  }

  Academicdesignationselected(designationId: string, admNo: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getcounsellingURL() + "/auth/jwt/student/academicCounsel/designationWiseFaculties?designationId=" + designationId + '&' + 'admNo=' + admNo, { headers });
  }

  academicsave(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(this.base.getcounsellingURL() + "/auth/jwt/student/academicCounsel/saveDetails", payload, { headers });
  }

  academicTableget() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getcounsellingURL() + "/auth/jwt/student/academicCounsel/overallReports", { headers });
  }

  //CCTV ADD DVR org fusion code //

  orafusion(searchorg: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get<any>(this.base.getcounsellingURL() + '/jwtV2/api/common/buildingDetailsByFusionCode?orcFusionBuildingCode=' + searchorg, { headers });
  }
  dvrcampusdetails(buildingId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/buildings?buildingId=' + buildingId, { headers });
  }

  Adddvrsave(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post<any>(environment.cctvURL + '/ses/cctv/saveCctvDetails', payload, { headers });
  }
  // END CCTV ADD DVR org fusion code //

  searchStudents(keyword: string): Observable<any[]> {
    return this.http.get<any[]>(
      this.baseUrl + keyword
    );
  }

    saveSchoolDetails(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post<any>(environment.masterDomain+"/anonymouseUser/login/saveSchoolDetails", payload, { headers });
  }
  
getUserForms() {
    return this.rolemanagement();
  }

  /**
   * Role / app-forms for the logged-in employee (sidebar menu source).
   * Cached after first successful call.
   */
  rolemanagement(payrollId?: string | null) {
    const userId = payrollId || localStorage.getItem('userId');

    if (this.userFormsCache) {
      return of(this.userFormsCache);
    }

    return this.http.get<any>(
      `${environment.masterDomain}/employee/api/jwtV2/common/userRoles?payrollId=${userId}`
    ).pipe(
      tap(res => this.userFormsCache = res)
    );
  }

  clearUserFormsCache(): void {
    this.userFormsCache = null;
  }

  rolemanagementWeb(payrollId?:any ,web?:any): Observable<any> {
    const userId = payrollId || localStorage.getItem('userId');

    if (this.userFormsCache) {
      return of(this.userFormsCache);
    }

    return this.http.get<any>(
        `${environment.masterDomain}/employee/api/jwtV2/common/V2/userRoles?payrollId=${userId}&&platform=${web}`
      ).pipe(
        tap(res => this.userFormsCache = res)
      );
    }

}


